import { createAction, createRequestTypes, createRequestActions } from './utils';
import keyMirror from 'react-utils/keyMirror';
import NotificationTypes from '../constants/NotificationTypes';
export const NotificationActionTypes = keyMirror({
  LOAD_NOTIFICATIONS: null,
  FETCH_NOTIFICATIONS: null,
  UPDATE_WEEKLY_PROGRESS_REPORT_SUBSCRIPTION: null,
  UPDATE_MONTHLY_MARKETING_REPORT_SUBSCRIPTION: null,
  UPDATE_CALENDAR_NOTIFICATION: null,
  UPDATE_PROJECTS_NOTIFICATION: null,
  UPDATE_LEAD_REVISIT_NOTIFICATION: null,
  UPDATE_SUCCESS_NOTIFICATION: null,
  RESEND_MONTHLY_MARKETING_REPORT: null,
  RESEND_WEEKLY_PROGRESS_REPORT: null,
  SEND_MONTHLY_MARKETING_REPORT: null,
  SEND_WEEKLY_PROGRESS_REPORT: null
});
export const FetchNotificationsActionTypes = createRequestTypes(NotificationActionTypes.FETCH_NOTIFICATIONS);
export const FetchNotifications = createRequestActions(FetchNotificationsActionTypes);
export const loadNotifications = () => createAction(NotificationActionTypes.LOAD_NOTIFICATIONS);
export const UpdateWeeklyProgressReportSubscriptionActionTypes = createRequestTypes(NotificationActionTypes.UPDATE_WEEKLY_PROGRESS_REPORT_SUBSCRIPTION);
export const UpdateWeeklyProgressReportSubscription = createRequestActions(UpdateWeeklyProgressReportSubscriptionActionTypes);
export const updateWeeklyProgressReportSubscription = subscribed => createAction(NotificationActionTypes.UPDATE_WEEKLY_PROGRESS_REPORT_SUBSCRIPTION, {
  data: {
    notificationType: NotificationTypes.WEEKLY,
    subscribed
  }
});
export const UpdateMonthlyMarketingReportSubscriptionActionTypes = createRequestTypes(NotificationActionTypes.UPDATE_MONTHLY_MARKETING_REPORT_SUBSCRIPTION);
export const UpdateMonthlyMarketingReportSubscription = createRequestActions(UpdateMonthlyMarketingReportSubscriptionActionTypes);
export const updateMonthlyMarketingReportSubscription = subscribed => createAction(NotificationActionTypes.UPDATE_MONTHLY_MARKETING_REPORT_SUBSCRIPTION, {
  data: {
    notificationType: NotificationTypes.MONTHLY,
    subscribed
  }
});
export const UpdateCalendarNotificationActionTypes = createRequestTypes(NotificationActionTypes.UPDATE_CALENDAR_NOTIFICATION);
export const UpdateCalendarNotification = createRequestActions(UpdateCalendarNotificationActionTypes);
export const updateCalendarNotification = subscribed => createAction(NotificationActionTypes.UPDATE_CALENDAR_NOTIFICATION, {
  data: {
    notificationType: NotificationTypes.CALENDAR,
    subscribed
  }
});
export const UpdateSuccessNotificationActionTypes = createRequestTypes(NotificationActionTypes.UPDATE_SUCCESS_NOTIFICATION);
export const UpdateSuccessNotification = createRequestActions(UpdateSuccessNotificationActionTypes);
export const updateSuccessNotification = subscribed => createAction(NotificationActionTypes.UPDATE_SUCCESS_NOTIFICATION, {
  data: {
    notificationType: NotificationTypes.SUCCESS_REPLY,
    subscribed
  }
});
export const UpdateProjectsNotificationActionTypes = createRequestTypes(NotificationActionTypes.UPDATE_PROJECTS_NOTIFICATION);
export const UpdateProjectsNotification = createRequestActions(UpdateProjectsNotificationActionTypes);
export const updateProjectNotification = subscribed => createAction(NotificationActionTypes.UPDATE_PROJECTS_NOTIFICATION, {
  data: {
    notificationType: NotificationTypes.PROJECTS,
    subscribed
  }
});
export const UpdateLeadRevisitNotificationActionTypes = createRequestTypes(NotificationActionTypes.UPDATE_LEAD_REVISIT_NOTIFICATION);
export const UpdateLeadRevisitNotification = createRequestActions(UpdateLeadRevisitNotificationActionTypes);
export const updateLeadRevisitNotification = leadRevisitType => createAction(NotificationActionTypes.UPDATE_LEAD_REVISIT_NOTIFICATION, {
  data: {
    leadRevisitType
  }
});
export const ResendWeeklyProgressReportActionTypes = createRequestTypes(NotificationActionTypes.RESEND_WEEKLY_PROGRESS_REPORT);
export const ResendWeeklyProgressReport = createRequestActions(ResendWeeklyProgressReportActionTypes);
export const resendWeeklyProgressReport = () => createAction(NotificationActionTypes.RESEND_WEEKLY_PROGRESS_REPORT, {
  data: {
    notificationType: NotificationTypes.WEEKLY
  }
});
export const ResendMonthlyMarketingReportActionTypes = createRequestTypes(NotificationActionTypes.RESEND_MONTHLY_MARKETING_REPORT);
export const ResendMonthlyMarketingReport = createRequestActions(ResendMonthlyMarketingReportActionTypes);
export const resendMonthlyMarketingReport = () => createAction(NotificationActionTypes.RESEND_MONTHLY_MARKETING_REPORT, {
  data: {
    notificationType: NotificationTypes.MONTHLY
  }
});
export const SendWeeklyProgressReportActionTypes = createRequestTypes(NotificationActionTypes.SEND_WEEKLY_PROGRESS_REPORT);
export const SendWeeklyProgressReport = createRequestActions(SendWeeklyProgressReportActionTypes);
export const sendWeeklyProgressReport = emailAddresses => createAction(NotificationActionTypes.SEND_WEEKLY_PROGRESS_REPORT, {
  data: {
    notificationType: NotificationTypes.WEEKLY,
    emailAddresses
  }
});
export const SendMonthlyMarketingReportActionTypes = createRequestTypes(NotificationActionTypes.SEND_MONTHLY_MARKETING_REPORT);
export const SendMonthlyMarketingReport = createRequestActions(SendMonthlyMarketingReportActionTypes);
export const sendMonthlyMarketingReport = emailAddresses => createAction(NotificationActionTypes.SEND_MONTHLY_MARKETING_REPORT, {
  data: {
    notificationType: NotificationTypes.MONTHLY,
    emailAddresses
  }
});